
import "bootstrap/js/src/collapse";
import "../Scss/custom.scss";
import { ToTheTop } from "./Modules/toTheTop";
import { PgpEncrypt } from "./Modules/pgpencrypt";

(function () {

    document.addEventListener('DOMContentLoaded', function (event) {

        const buttonToTheTop = document.getElementById('toThetop');
        if(buttonToTheTop) {
            const toTheTop = new ToTheTop(buttonToTheTop);
        }

        const encryptedFields = document.querySelectorAll('input[type="hidden"].pgpencrypted');
        encryptedFields.forEach((encryptedField) => {
            const form = document.getElementById(encryptedField.dataset['formreference']);
            if(form) {

                const submitButton = form.querySelector('[type="submit"]');


                form.addEventListener('submit', async (event) => {
                    event.preventDefault();
                    const hiddenField = event.currentTarget.querySelector('input[type="hidden"].pgpencrypted');
                    if(hiddenField) {
                        const publicKey = hiddenField.dataset['pgppublickey'];
                        const fields = hiddenField.dataset['fields'];

                        if (publicKey && fields) {
                            const fieldIdArray = fields.split(',').map(item => item.trim());
                            const fieldArray = fieldIdArray.map(id => event.currentTarget.querySelector(`[id$="${id}"]`));
                            const pgpEncrypt = new PgpEncrypt(event.currentTarget, publicKey, fieldArray);

                            hiddenField.value = await pgpEncrypt.encryptFields(true);
                            if(hiddenField.value) {
                                form.querySelector('#currentPage').value = submitButton.value;
                                await pgpEncrypt.clearUnencryptedFields();
                                form.submit();
                            }
                        }
                    }
                });

            }
        });

    });

})();
